<template>
    <div>
        <div class="row">
            <div class="col text-center">
                <b-img :src="courseDetails.course_thumbnail" fluid alt="Responsive image"></b-img>
            </div>
        </div>
        <hr>
        <div class="row mb-3">
            <div class="col-sm-6">
                <section class="h-100 p-3">
                    <h3>
                        <icon name="file-alt" style="width: 30px; height: 30px"></icon>
                        คำอธิบายหลักสูตร
                    </h3>
                    <b-row>
                        <b-col v-html="courseDetails.course_detail"></b-col>
                    </b-row>
                </section>
            </div>
            <div class="col-sm-6">
                <section class="h-100 p-3" v-if="typeof courseDetails.course_objective !== 'undefined'">
                    <h3>
                        <icon name="flag-checkered" style="width: 30px; height: 30px"></icon>
                        วัตถุประสงค์
                    </h3>
                    <li :key="index"
                        v-for="(objective, index) in JSON.parse(`${courseDetails.course_objective}`)"
                        v-html="objective"
                    >
                    </li>
                </section>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-sm-6">
                <section class="h-100 p-3">
                    <h3>
                        <icon name="user" style="width: 30px; height: 30px"></icon>
                        หลักสูตรนี้เหมาะสำหรับ
                    </h3>
                    <p>{{ courseDetails.course_for_text }}</p>
                </section>
            </div>
            <div class="col-sm-6">
                <section class="h-100 p-3">
                    <h3>
                        <icon name="check-circle" style="width: 30px; height: 30px"></icon>
                        ระดับเนื้อหา
                    </h3>
                    <p>{{ courseLevelText(courseDetails.course_level) }}</p>
                </section>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-sm-6" v-show="courseDetails.has_certificate">
                <section class="h-100 p-3">
                    <h3>
                        <icon name="certificate" style="width: 30px; height: 30px"></icon>
                        การรับวุฒิบัตร
                    </h3>
                    <p>คะแนนรวมไม่น้อยกว่า 80%</p>
                </section>
            </div>
            <div class="col-sm-6" v-show="courseDetails.score">
                <section class="h-100 p-3">
                    <h3>
                        คะแนนรวม
                    </h3>
                    <p>{{ courseDetails.score }}/{{ courseDetails.maxScore }}</p>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CourseDetails",
        props: ['courseDetails'],
        data() {
            return {
                courseCode: this.$route.params.id
            }
        },
        methods: {
            courseLevelText(lvl) {
                let text;
                if (lvl === 3) {
                    text = "ระดับสูง (Advance)";
                } else if (lvl === 2) {
                    text = "ระดับกลาง (Intermediate)";
                } else {
                    text = "ระดับเริ่มต้น (Beginner)";
                }
                return text;
            }
        }
    }
</script>

<style scoped>
    section {
        border-bottom: 1px solid #ccc;
    }
</style>